import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'app-hub-selector',
    templateUrl: './hub-selector.component.html',
    styleUrls: ['./hub-selector.component.scss'],
    standalone: false
})
export class HubSelectorComponent implements OnInit {
  @Input() sharerHubs: any[];
  @Output() selectHubEvent = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
    console.log('sharerHubs: ', this.sharerHubs);
  }

  selectHub(hub: any) {
    this.selectHubEvent.emit(hub);
  }

}
